export default __webpack_public_path__ + "static/media/photogallery-07.a68cb773.webp";